import { formatDateForLocale } from '@/utils/helpers';
import { addLocalePath } from '@/utils/urlBuilder/utils';

export function convertFilesToObject(buttons) {
  const buttonsObject = {};
  buttons?.forEach(button => {
    buttonsObject[button.platform] = {
      fileUrl: button.file_url,
      fileSize: button.file_size,
    };
  });
  return buttonsObject;
}

export const getMetaTitle = (
  downloadTitle: string,
  product: Product | null = null
): string => {
  return product
    ? `${product.content || product.title} - ${downloadTitle}`
    : downloadTitle;
};

const getPrusaSlicerForDownload = downloads => {
  // const targetProducts = [
  //   'mk2-5',
  //   'mk2-5s',
  //   'mk3',
  //   'mk3s',
  //   'mmu1',
  //   'mmu2s',
  //   'sl1',
  //   'cw1',
  //   'mini',
  //   'mk2s',
  //   'mk3s-2',
  //   'mini-2',
  //   'sl1s',
  //   'cw1s',
  //   'xl',
  // ];

  // Filter driver items that have all target products
  const prusaSlicerItems = downloads.filter(download => {
    return download.meta.type.value === 'driver';
  });

  // If no items found, return null
  if (prusaSlicerItems.length === 0) {
    return null;
  }

  // Sort by release date
  return prusaSlicerItems.sort(
    (a, b) =>
      // sort by id descending
      b.id - a.id
    // b.meta.release_date.localeCompare(a.meta.release_date)
  );
};

export const getDownloadsList = (locale, allCategories, downloadItems) => {
  const categoriesState = {} as DownloadCategories;

  allCategories.forEach(category => {
    categoriesState[category?.slug] = {
      id: category.id,
      title: category.title,
      slug: category?.slug,
      rss: 'https://www.prusa3d.cz/',
      image: category.media?.image,
      link: addLocalePath(locale, `product/${category?.slug}`),
    };
  });

  // Get PrusaSlicer
  const prusaSlicerItems = getPrusaSlicerForDownload(downloadItems);

  if (prusaSlicerItems) {
    categoriesState.prusaslicer = {
      slug: 'prusaslicer',
      title: 'PrusaSlicer',
      link: addLocalePath(locale, `category/prusaslicer_204`),
      image: {
        src: '/visuals/images/logo-prusaslicer.png',
      },
      firmware: prusaSlicerItems.map(item => ({
        title: item.title,
        content: item.content,
        date: formatDateForLocale(locale, item.meta.release_date),
        releaseLogUrl: item.meta.release_log_url,
        files: convertFilesToObject(item.meta.files),
        type: {
          value: item.meta.type.value,
          label: 'PrusaSlicer',
        },
        meta: item.meta,
      })),
    };
  }

  // Remaining downloads items
  downloadItems.forEach(item => {
    item.products?.forEach(tagId => {
      if (Object.hasOwnProperty.call(categoriesState, tagId)) {
        const typeValue = item.meta.type.value;
        if (!categoriesState[tagId][typeValue]) {
          categoriesState[tagId][typeValue] = [];
        }

        categoriesState[tagId][typeValue].push({
          title: item.title,
          content: item.content,
          date: formatDateForLocale(locale, item.meta.release_date),
          releaseLogUrl: item.meta.release_log_url,
          files: convertFilesToObject(item.meta.files),
          type: item.meta.type,
          meta: item.meta,
        });
      }
    });
  });

  // Sort arrays by release date
  Object.keys(categoriesState).forEach(key => {
    if (key !== 'prusaslicer') {
      Object.keys(categoriesState[key]).forEach(typeValue => {
        if (Array.isArray(categoriesState[key][typeValue])) {
          categoriesState[key][typeValue].sort((a, b) =>
            b.meta.release_date.localeCompare(a.meta.release_date)
          );
        }
      });
    }
  });

  return categoriesState;
};
